'use strict';

import * as Props from '../Props';

const angular = require('angular');

const LabelPropertise = {
    Basic: {
        'ControlType': 'Label',
        'Text': {
            name: 'text',
            selectedValue: 'Label',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe'
        },
        'Field Name': Props.getFieldName('Label'),
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        }
    },
    Display: {
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: angular.copy(Props.styleObject),
    Margin: angular.copy(Props.marginObject)
};

export default LabelPropertise;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Label.ts